import { render, staticRenderFns } from "./AddPaper.vue?vue&type=template&id=9369ea50&"
import script from "./AddPaper.vue?vue&type=script&lang=js&"
export * from "./AddPaper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports